import { AnomalyUI, SessionReviewUI } from '@shared';

export type ExamAuditTableCellsPropsType = {
  entries: {
    start: number;
    end: number;
    label: string;
    description: string[];
  };
  onSeekChange: (seek: number, isPlay: boolean) => void;
};

export type SwitchAnomaliesPropsType = Pick<SessionReviewUI, 'anomalyTypeViews'> & {
  onSwitch: ({ type, payload }: ActionsType) => void;
};

export enum Actions {
  HIDE = 'HIDE',
  SHOW = 'SHOW',
  ANOMALIESREADY = 'ANOMALIESREADY',
}

export type ActionsType =
  | {
      type: Actions.ANOMALIESREADY;
      payload: AnomalyUI[];
    }
  | {
      type: Actions.HIDE;
      payload: number;
    }
  | {
      type: Actions.SHOW;
      payload: number;
    };

export type ColumnsIds = 'anomalies' | 'start' | 'end' | 'description' | 'label';
